import React from 'react';
import { Link } from 'react-router-dom';

import { $ } from 'jquery'
import Swal from 'sweetalert2';
import MUIDataTable from 'mui-datatables';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Toggle from 'react-toggle';
import {
	Tooltip,
	// FormGroup,
	// FormLabel,
	// TextField,
	// Button,
	// Select,
	// FormControl,
	// InputLabel,
} from '@material-ui/core';
import { getCarServices } from '../../actions/homeAction';
import { createMuiTheme } from '@material-ui/core/styles';
import { FaEdit } from 'react-icons/fa';
// import MuiThemeProvider from '@material-ui/core/styles/MuiThemeProvider';

class CarService extends React.Component {
	getMuiTheme = () =>
		createMuiTheme({
			overrides: {
				MUIDataTable: {
					responsiveStacked: {
						maxHeight: '35vh',
						overflowX: 'none',
					},
				},
				MUIDataTableHeadCell: {
					root: {
						width: '80px',
						fontWeight: 'bold',
						padding: '5px',
						lineHeight: '10px',
						whiteSpace: 'normal',
						overflow: 'hidden',
						//           wordWrap: "break-word",
						fontSize: '10px',
					},
				},
				MUIDataTableBodyCell: {
					root: {
						width: '80px',
						fontSize: '9px', // border:'1px solid black',
						padding: '5px',
						whiteSpace: 'normal',
						wordWrap: 'break-word',
					},
				},
			},
		});
	// constructor() {
	// 	super();
	// 	this.state = {};
	// }
	state = { list: [] };
	handleStatusChange = sid => {
		var isChecked = $('#cattogBtn_' + sid);
		var status = ''
		isChecked.prop('checked', !isChecked.prop('checked'));
		console.log(isChecked.prop('checked'), !isChecked.prop('checked'));
		if (!isChecked.prop('checked') === true) {
			 status = 'active';
		} else {
			 status = 'inactive';
		}
		let newArray = this.state.user_list;
		var a = newArray.find(element => {
			return element.id === sid;
		});
		a.status = status;
		console.log(newArray);
		this.setState({ user_list: newArray });
		Swal.fire('Update Status!', 'Status has been updated.', 'success');
	};

	componentDidUpdate(prevProps) {
		console.log('hello 1', prevProps);

		if (prevProps.location.pathname !== this.props.location.pathname) {
			console.log('hello 2');
			if (this.props.match.params.type === 'countryCode') {
				this.setState({
					user_list: [{ ServiceType: 'country code' }, { ServiceType: 'code' }],
				});
			} else if (this.props.match.params.type === 'CountryList') {
				console.log('under spare part');
				this.setState({
					user_list: [{ ServiceType: 'country list' }, { ServiceType: 'list' }],
				});
			} else if (this.props.match.params.type) {
			}
		}
	}

	componentDidMount() {
		this.props.getCarServices();
	}

	render() {
		let columns = [];

		columns = [
			{
				name: 'service',
				label: 'AC Service Name',
				options: {
					filter: false,
					sort: true,
				},
			},

			{
				name: 'priority',
				label: 'Priority ',
				options: {
					filter: false,

					customBodyRender: (priority) => {
						// console.log('thsi is table', tableMeta);
						return <span>{priority}</span>;
					},
				},
			},

			{
				name: 'active',
				label: 'Status',
				options: {
					filter: true,
					sort: true,
					customBodyRender: (active, tableMeta) => {
						var Id = tableMeta.rowData[4];
						// console.log(tableMeta.rowData[6]);
						return (
							<Toggle
								id={'status_' + Id}
								checked={active}
								value={active}
								onChange={this.handleStatusChange.bind(this, Id, active)}
							/>
						);
					},
				},
			},
			{
				name: 'serviceId',
				label: 'Actions',
				options: {
					filter: false,
					sort: true,
					customBodyRender: (garageOwnerId) => {
						return(
							<div>
								<Link to={`/ServiceTypeMaster/CarService/Update/${garageOwnerId}`}>
									<FaEdit style={{fontSize: '1.4rem'}} />
								</Link>
							</div>
						)
					}
				},
			},
		];

		const options = {
			filter: false,
			viewColumns: false,
			print: false,
			download: false,
			selectableRows: 'none',
			textLabels: {
				body: {
					noMatch: this.state.isSaving
						? 'Loading data..!'
						: 'Sorry, No Users Found',
					toolTip: 'Sort',
					columnHeaderTooltip: column => `Sort for ${column.label}`,
				},
			},
		};
		return (
			<div className='pcoded-inner-content'>
				<div className='main-body'>
					<div className='page-wrapper'>
						<div className='row'>
							<div className='col-sm-12'>
								<div className='card'>
									<div className='card-header'>
										<Link
											to={`/ServiceTypeMaster/Add/CarService`}
											className='btn btn-sm btn-inverse waves-effect waves-light f-right d-inline-block md-trigger'
											data-modal='modal-13'>
											{' '}
											<i className='icofont icofont-plus m-r-5'></i>
											Add AC Services
										</Link>
									</div>

									<div className='card-block'>
										<div className='dt-responsive table-responsive'>
											<button
												className='f-right bg-white b-none'
												data-modal='modal-13'>
												<Tooltip
													title='Download Selected'
													aria-label='download'
													onClick={() => {
														this.exportCSVS();
													}}>
													<i
														className='icofont icofont-download-alt'
														style={{
															fontSize: '30px',
															color: 'grey',
														}}></i>
												</Tooltip>
											</button>

											{/* <MuiThemeProvider theme={this.getMuiTheme()}> */}
											{this.props.ServicesList !== undefined ? (
												<MUIDataTable
													title={`AC Services`}
													className='table-responsive'
													data={this.props.ServicesList}
													columns={columns}
													options={options}
												/>
											) : (
												<h4>Loading...</h4>
											)}
											{/* </MuiThemeProvider> */}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

CarService.propsTypes = { getCarServices: PropTypes.func.isRequired };

var mapStateToProps = state => ({
	ServicesList: state?.home?.ServicesList?.response,
});

export default connect(mapStateToProps, { getCarServices })(CarService);
